var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 25C12.3288 25 13.1237 24.6708 13.7097 24.0847C14.2958 23.4987 14.625 22.7038 14.625 21.875H8.375C8.375 22.7038 8.70424 23.4987 9.29029 24.0847C9.87634 24.6708 10.6712 25 11.5 25ZM13.0547 1.71721C13.0765 1.49995 13.0525 1.28053 12.9843 1.07311C12.9161 0.865681 12.8052 0.674852 12.6587 0.512928C12.5122 0.351003 12.3334 0.221578 12.1339 0.133C11.9343 0.044422 11.7184 -0.00134277 11.5 -0.00134277C11.2816 -0.00134277 11.0657 0.044422 10.8661 0.133C10.6666 0.221578 10.4878 0.351003 10.3413 0.512928C10.1948 0.674852 10.0839 0.865681 10.0157 1.07311C9.94748 1.28053 9.9235 1.49995 9.94531 1.71721C8.17925 2.07643 6.5916 3.03496 5.45119 4.43049C4.31079 5.82603 3.68773 7.5728 3.6875 9.37502C3.6875 11.0906 2.90625 18.75 0.5625 20.3125H22.4375C20.0938 18.75 19.3125 11.0906 19.3125 9.37502C19.3125 5.59377 16.625 2.43752 13.0547 1.71721Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.c63a2b93.svg";
export { ForwardRef as ReactComponent };